import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('recipe-list')

export default function RecipeList({ recipes, title }) {
  return (
    <section {...bem('')}>
      <h2 {...bem('title')}>
        {title || 'Prøv en av oppskriftene våre i appen Foodsteps'}
      </h2>

      <ul {...bem('list')}>
        {recipes &&
          recipes.map(({ node: { title, id, image } }) => (
            <li key={id} {...bem('item')}>
              {image.url && <img src={image.url} {...bem('image')} alt="" />}
              {title && (
                <div {...bem('content')}>
                  <h3 {...bem('name')}>{title}</h3>
                </div>
              )}
            </li>
          ))}
      </ul>
    </section>
  )
}

RecipeList.propTypes = {
  title: T.any,
  recipes: T.array.isRequired,
}
